import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Subject } from 'rxjs';

import { SearchEngineTypeLabel } from 'modules/shared/models/screening.models';

export interface NoCreditDialogData {
  noCreditSearchEngines: Array<SearchEngineTypeLabel | string>;
  hideContinueButton: boolean;
}

@Component({
  selector: 'artemis-no-credit-warning-dialog',
  templateUrl: './no-credit-warning-dialog.component.html',
  styleUrls: ['./no-credit-warning-dialog.component.scss']
})
export class NoCreditWarningDialogComponent implements OnInit {

  noCreditSearchEngines: string;
  hideContinueButton: boolean = false;

  dialogAction: Subject<string> = new Subject();

  constructor(private dialogRef: MatDialogRef<any>,
              @Inject(MAT_DIALOG_DATA) data: NoCreditDialogData) {
    this.noCreditSearchEngines = data.noCreditSearchEngines.join(', ');
    this.hideContinueButton = data.hideContinueButton;
  }

  ngOnInit() {
  }

  /**
   * @method closeDialog
   * To close this dialog
   */
  closeDialog(): void {
    this.dialogAction.next('close');
    this.dialogRef.close();
  }

  /**
   * When user click CONTINUE in the dialog
   * @method continueAction
   */
  continueAction(): void {
    this.dialogAction.next('continue');
    this.dialogRef.close();
  }
}
